import type { SupplyTableProduct } from '@/services/supplyService';
import { isSupplyTableRowUrgentRed } from '@/utils/supplyUrgency';

const SUPPLY_APPLY_MOQ_MP_KEY = 'supply_applyMoqMp';
const SUPPLY_SHOW_ONLY_SUGGESTED_GREATER_ZERO_KEY = 'supply_showOnlySuggestedGreaterZero';
const SUPPLY_SHOW_ONLY_NEEDS_REORDER_KEY = 'supply_showOnlyNeedsReorder';

export function readSupplyApplyMoqMpFromSession(): boolean {
  try {
    const item = sessionStorage.getItem(SUPPLY_APPLY_MOQ_MP_KEY);
    if (item === null) return true;
    return JSON.parse(item) as boolean;
  } catch {
    return true;
  }
}

export function readSupplyShowOnlySuggestedGreaterZeroFromSession(): boolean {
  try {
    const item = sessionStorage.getItem(SUPPLY_SHOW_ONLY_SUGGESTED_GREATER_ZERO_KEY);
    if (item === null) return true;
    return JSON.parse(item) as boolean;
  } catch {
    return true;
  }
}

export function readSupplyShowOnlyNeedsReorderFromSession(): boolean {
  try {
    const item = sessionStorage.getItem(SUPPLY_SHOW_ONLY_NEEDS_REORDER_KEY);
    if (item === null) return false;
    return JSON.parse(item) as boolean;
  } catch {
    return false;
  }
}

/** Réplica de `commitBasicKpisFromRows` en SupplyPage antes de calcular KPIs. */
export function filterRowsForSupplyKpis(rows: SupplyTableProduct[]): SupplyTableProduct[] {
  const showOnlyNeedsReorder = readSupplyShowOnlyNeedsReorderFromSession();
  const showOnlySuggestedGreaterZero = readSupplyShowOnlySuggestedGreaterZeroFromSession();

  if (showOnlyNeedsReorder) {
    return rows.filter(isSupplyTableRowUrgentRed);
  }
  if (showOnlySuggestedGreaterZero) {
    return rows.filter((product) => (product.cantidad_sugerida_sistema ?? 0) > 0);
  }
  return rows;
}

/** Misma regla que `calculateKpisFromData` en SupplyPage. */
export function countSupplyUrgentProducts(rows: SupplyTableProduct[]): number {
  const kpiRows = filterRowsForSupplyKpis(rows);
  return kpiRows.filter(isSupplyTableRowUrgentRed).length;
}

export function getSupplyTableParamsForHomeKpis(warehouseId: number, applyMoqMp: boolean) {
  return {
    warehouse_id: warehouseId,
    needs_reorder: readSupplyShowOnlyNeedsReorderFromSession(),
    suggested_greater_zero: readSupplyShowOnlySuggestedGreaterZeroFromSession(),
    apply_moq_mp: applyMoqMp,
    page: 1,
    page_size: 1,
    metrics_only: true as const,
  };
}
